// src/features/wallet/components/WalletInfoCard.tsx
import { Card, formatSolarDate } from '../../../app/components/foundation';
import type { Wallet } from '../types/wallet.types';
import { WalletStatusBadge } from './WalletStatusBadge';

export interface WalletInfoCardProps {
  wallet: Wallet;
}

/**
 * Workspace card: core wallet info. Pulls straight off the base
 * Wallet record (same shape the list table already uses) — no
 * additional mock data needed for this one. Same field-list markup as
 * commission/components/CommissionInfoCard.tsx and
 * orders/components/OrderInfoCard.tsx.
 */
export function WalletInfoCard({ wallet }: WalletInfoCardProps) {
  return (
    <Card className="vania-wallet-workspace-card">
      <h2 className="vania-wallet-workspace-card-title">اطلاعات کیف پول</h2>

      <dl className="vania-wallet-workspace-fieldlist">
        <div>
          <dt>شناسه کاربر</dt>
          <dd dir="ltr">{wallet.id}</dd>
        </div>
        <div>
          <dt>شناسه تلگرام</dt>
          <dd dir="ltr">{wallet.telegram_id}</dd>
        </div>
        <div>
          <dt>موبایل</dt>
          <dd dir="ltr">{wallet.mobile || '-'}</dd>
        </div>
        <div>
          <dt>وضعیت</dt>
          <dd>
            <WalletStatusBadge status={wallet.status} />
          </dd>
        </div>
        <div>
          <dt>تاریخ ایجاد</dt>
          <dd dir="ltr">{formatSolarDate(wallet.created_at || '-')}</dd>
        </div>
      </dl>
    </Card>
  );
}
